module.exports = __webpack_public_path__ + "static/img/nothing_service.df2f02d2.png";